import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { RootState } from '../../../redux/store';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../shared/constants/routes';
import {
	ANALYTICS_EVENTS,
	EVENT_TYPES,
} from '../../../shared/constants/events';
import { isSessionStorageEnabled } from '../../../shared/utils/general.util';
import bannerSubscriptions from '../../../assets/img/banners/subscribe_mobile.png';
import bannerSubscriptionsDesktop from '../../../assets/img/banners/subscribe_desktop.png';
import fiscalComplianceBanner from '../../../assets/img/banners/fiscal_compliance_mobile.png';
import fiscalComplianceBannerDesktop from '../../../assets/img/banners/fiscal_compliance_desktop.png';
import SatDownBannerDesktop from '../../../assets/img/banners/sat_down_banner_desktop.png';
import SatDownBannerMobile from '../../../assets/img/banners/sat_down_banner_mobile.png';

import { settingsCarrousel } from '../../../shared/utils/settings';
import LOCAL_STORAGE_KEY from '../../../shared/constants/localStorageKey';
import { setOverwriteUtm, updateUTMs } from '../../../redux/slices/cart.slice';
import useCleverTapEvent from '../../../hooks/useClevertapEvent';
import useGrowthbookExperiment from '../../../hooks/useGrowthbookExperiment';
import ModalFrame from '../../../components/molecules/ModalFrame';
import { PRODUCTS_BY_SLUG } from '../../../shared/constants/ecommerceData';
import { useMediaQuery } from '@mui/material';

type BannerItem = {
	src: string;
	alt: string;
	onClick: () => void;
};

export const BannersHome = ({
	callbackAction,
}: {
	callbackAction: () => void;
}) => {
	const { satIsDown } = useGrowthbookExperiment();
	const [showModal, setShowModal] = useState({
		fiscalCompliance: false,
		annualArticle: false,
		negativeCompliance: false,
		satDown: false,
	});
	const { user: userProfile } = useSelector(
		(state: RootState) => state.profile,
	);
	const navigate = useNavigate();
	const logClevertapEvent = useCleverTapEvent();
	const dispatch = useDispatch();
	const { activeSuscriptions, hasPendingAnalysis } = useSelector(
		(state: RootState) => state.profile,
	);

	const legacySubscriptions = [
		PRODUCTS_BY_SLUG.HERU_PLUS,
		PRODUCTS_BY_SLUG.ACTIVIDAD_EMPRESARIAL,
		PRODUCTS_BY_SLUG.RESICO,
		PRODUCTS_BY_SLUG.PLATAFORMAS_TECNOLOGICAS,
		PRODUCTS_BY_SLUG.ARR_MONTHLY,
		PRODUCTS_BY_SLUG.PLAN_ENTREPRENEUR,
		PRODUCTS_BY_SLUG.PLAN_PLATFORM,
		PRODUCTS_BY_SLUG.PLAN_BUSINESS,
	];

	const userHaveSubscription = activeSuscriptions?.some((sub) =>
		legacySubscriptions?.includes(
			sub.product_version?.product?.slug as PRODUCTS_BY_SLUG,
		),
	);

	const logBannerHomeEvent = (banner: 'planes y precios' | 'suscripcion') => {
		logClevertapEvent(ANALYTICS_EVENTS.HOME_LINK, {
			event_type: EVENT_TYPES.HOME_PURCHASE_BANNER_INTERACTION,
			id: userProfile?.id!,
			phone: userProfile?.cellphone!,
			banner,
		});
	};
	const goToPlans = () => {
		logBannerHomeEvent('planes y precios');
		if (isSessionStorageEnabled()) {
			const overwriteUtmKey = LOCAL_STORAGE_KEY.OVERWRITE_UTM;

			let overwriteUtm = sessionStorage.getItem(overwriteUtmKey);

			if (overwriteUtm === null) {
				sessionStorage.setItem(overwriteUtmKey, 'true');
				overwriteUtm = 'true';
			}
		} else {
			const currentOverwriteUtm = useSelector(
				(state: RootState) => state.cart.overwriteUtm,
			);

			if (currentOverwriteUtm === undefined || currentOverwriteUtm === null) {
				dispatch(setOverwriteUtm(true));
			}

			if (currentOverwriteUtm === true) {
			} else {
				const currentUTMs = useSelector(
					(state: RootState) => state.cart.utmInfo,
				);

				if (!currentUTMs) return;
				const updatedUTMs = {
					...currentUTMs,
					utm_campaign: currentUTMs?.utm_campaign,
					utm_medium: currentUTMs?.utm_medium,
					utm_source: currentUTMs?.utm_source,
				};
				dispatch(updateUTMs(updatedUTMs));
			}
		}

		const params = hasPendingAnalysis ? '?show=analisis' : '';
		navigate(`${ROUTES.PLANS_AND_PRICES}${params}`);
	};

	const isMobile = useMediaQuery('(max-width: 768px)');

	const getActiveBanners = (): BannerItem[] => {
		const banners: BannerItem[] = [];

		if (satIsDown) {
			banners.push({
				src: isMobile ? SatDownBannerMobile : SatDownBannerDesktop,
				alt: 'SAT Caido',
				onClick: () =>
					setShowModal((prev) => ({
						...prev,
						satDown: true,
					})),
			});
		}

		banners.push({
			src: isMobile ? fiscalComplianceBanner : fiscalComplianceBannerDesktop,
			alt: 'Banner de cumplimiento fiscal',
			onClick: () =>
				setShowModal((prev) => ({
					...prev,
					fiscalCompliance: true,
					annualArticle: false,
				})),
		});

		if (!userHaveSubscription) {
			banners.push({
				src: isMobile ? bannerSubscriptions : bannerSubscriptionsDesktop,
				alt: 'Banner de compra suscripcion',
				onClick: () => {
					goToPlans();
					callbackAction();
				},
			});
		}

		return banners;
	};
	const activeBanners = getActiveBanners();

	if (activeBanners.length === 0) return null;
	return (
		<>
			<ModalFrame
				open={showModal.fiscalCompliance}
				onClose={() =>
					setShowModal((prev) => ({
						...prev,
						fiscalCompliance: false,
					}))
				}
				src='https://noticias.heru.app/en/articles/4287105'
			/>
			<ModalFrame
				open={showModal.satDown}
				onClose={() =>
					setShowModal((prev) => ({
						...prev,
						satDown: false,
					}))
				}
				src='https://noticias.heru.app/en/articles/5413057'
			/>
			<ModalFrame
				open={showModal.annualArticle}
				onClose={() =>
					setShowModal((prev) => ({
						...prev,
						fiscalCompliance: false,
					}))
				}
				src='https://noticias.heru.app/en/articles/4295297'
			/>

			<div className={`flex flex-col gap-4`}>
				<div className='border-2 border-white shadow rounded-lg'>
					{activeBanners?.length > 1 ? (
						<Slider
							{...settingsCarrousel}
							className='w-full'
						>
							{activeBanners.map((banner, index) => (
								<img
									key={index}
									onClick={banner.onClick}
									src={banner.src}
									alt={banner.alt}
									className='relative h-fit-content object-cover rounded-lg cursor-pointer'
								/>
							))}
						</Slider>
					) : (
						<img
							onClick={activeBanners?.[0]?.onClick}
							src={activeBanners?.[0]?.src}
							alt={activeBanners?.[0]?.alt}
							className='relative h-full object-cover rounded-lg cursor-pointer'
						/>
					)}
				</div>
			</div>
		</>
	);
};
